// formConfig.js - Form configuration options for all report types
export const organizationTypes = [
  { value: "Public", label: "Public" },
  { value: "Private", label: "Private" },
  { value: "Government", label: "Government" },
];

export const impactLevels = [
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const copIncidentTypes = [
  { value: "cyberbullying", label: "Cyberbullying/Harassment" },
  { value: "inappropriate_content", label: "Exposure to Inappropriate Content" },
  { value: "grooming", label: "Online Grooming/Exploitation" },
  { value: "privacy_violation", label: "Privacy Violation" },
  { value: "sextortion", label: "Sextortion" },
  { value: "cultural_abuse", label: "Cultural Abuse" },
  { value: "other", label: "Other" },
];

export const victimAgeRanges = [
  { value: "under_13", label: "Under 13" },
  { value: "13_17", label: "13-17" },
  { value: "unknown", label: "Unknown" },
];

export const relationshipOptions = [
  { value: "parent", label: "Parent/Guardian" },
  { value: "teacher", label: "Teacher" },
  { value: "friend", label: "Friend" },
  { value: "self", label: "Self" },
  { value: "other", label: "Other" },
  { value: "unknown", label: "Unknown" },
];

export const urgencyLevels = [
  { value: "normal", label: "Normal" },
  { value: "urgent", label: "Urgent" },
];

// Vulnerability Report Configurations
export const vulnerabilityTypes = [
  { value: "sql_injection", label: "SQL Injection" },
  { value: "xss", label: "Cross-Site Scripting (XSS)" },
  { value: "csrf", label: "Cross-Site Request Forgery (CSRF)" },
  { value: "rce", label: "Remote Code Execution (RCE)" },
  { value: "lfi", label: "Local File Inclusion (LFI)" },
  { value: "rfi", label: "Remote File Inclusion (RFI)" },
  { value: "authentication_bypass", label: "Authentication Bypass" },
  { value: "privilege_escalation", label: "Privilege Escalation" },
  { value: "information_disclosure", label: "Information Disclosure" },
  { value: "dos", label: "Denial of Service (DoS)" },
  { value: "buffer_overflow", label: "Buffer Overflow" },
  { value: "insecure_configuration", label: "Insecure Configuration" },
  { value: "other", label: "Other" },
];

export const severityLevels = [
  { value: "critical", label: "Critical (9.0-10.0)" },
  { value: "high", label: "High (7.0-8.9)" },
  { value: "medium", label: "Medium (4.0-6.9)" },
  { value: "low", label: "Low (0.1-3.9)" },
  { value: "none", label: "None (0.0)" },
];

export const discoveryMethods = [
  { value: "manual_testing", label: "Manual Testing" },
  { value: "automated_scanning", label: "Automated Scanning" },
  { value: "code_review", label: "Code Review" },
  { value: "penetration_testing", label: "Penetration Testing" },
  { value: "bug_bounty", label: "Bug Bounty Program" },
  { value: "incident_response", label: "Incident Response" },
  { value: "other", label: "Other" },
];

export const reporterTypes = [
  { value: "security_researcher", label: "Security Researcher" },
  { value: "employee", label: "Employee" },
  { value: "external_user", label: "External User" },
  { value: "customer", label: "Customer" },
  { value: "anonymous", label: "Anonymous" },
  { value: "other", label: "Other" },
];

// Malware Report Configurations
export const malwareTypes = [
  { value: "virus", label: "Virus" },
  { value: "trojan", label: "Trojan" },
  { value: "ransomware", label: "Ransomware" },
  { value: "spyware", label: "Spyware" },
  { value: "adware", label: "Adware" },
  { value: "rootkit", label: "Rootkit" },
  { value: "worm", label: "Worm" },
  { value: "botnet", label: "Botnet" },
  { value: "phishing", label: "Phishing" },
  { value: "other", label: "Other" },
];

export const detectionMethods = [
  { value: "antivirus", label: "Antivirus Detection" },
  { value: "behavior_analysis", label: "Behavioral Analysis" },
  { value: "network_monitoring", label: "Network Monitoring" },
  { value: "user_report", label: "User Report" },
  { value: "incident_response", label: "Incident Response" },
  { value: "other", label: "Other" },
];

export const infectionVectors = [
  { value: "email", label: "Email Attachment" },
  { value: "web_download", label: "Web Download" },
  { value: "usb", label: "USB/Removable Media" },
  { value: "network", label: "Network Propagation" },
  { value: "social_engineering", label: "Social Engineering" },
  { value: "software_vulnerability", label: "Software Vulnerability" },
  { value: "unidentified", label: "Unidentified" },
  { value: "other", label: "Other" },
];

export const platformTypes = [
  { value: "windows", label: "Windows" },
  { value: "linux", label: "Linux" },
];

// Abuse Report Configurations
export const abuseTypes = [
  { value: "cyberbullying", label: "Cyberbullying" },
  { value: "harassment", label: "Online Harassment" },
  { value: "doxxing", label: "Doxxing/Privacy Violation" },
  { value: "impersonation", label: "Identity Theft/Impersonation" },
  { value: "hate_speech", label: "Hate Speech" },
  { value: "threats", label: "Threats/Intimidation" },
  { value: "stalking", label: "Online Stalking" },
  { value: "other", label: "Other" },
];

export const abusePlatformTypes = [
  { value: "social_media", label: "Social Media" },
  { value: "gaming", label: "Gaming Platform" },
  { value: "messaging", label: "Messaging App" },
  { value: "email", label: "Email" },
  { value: "forum", label: "Forum/Community" },
  { value: "video_platform", label: "Video Platform" },
  { value: "other", label: "Other" },
];

export const relationshipToVictim = [
  { value: "self", label: "Self (I am the victim)" },
  { value: "parent", label: "Parent/Guardian" },
  { value: "friend", label: "Friend" },
  { value: "witness", label: "Witness" },
  { value: "teacher", label: "Teacher/Educator" },
  { value: "other", label: "Other" },
];

export const abuseUrgencyLevels = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];